(function () {
  let currentTimelineStep = 0;
  let totalSteps = 4;
  let currentTestimonial = 0;
  let totalTestimonials = 4;

  function isMobileCarousel() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  function updateTimeline() {
    document.querySelectorAll('.timeline-step').forEach(function (step) {
      step.classList.remove('active');
    });

    var activeStep = document.querySelector('[data-step="' + currentTimelineStep + '"]');
    if (activeStep) activeStep.classList.add('active');

    var progressFill = document.getElementById('progressFill');
    if (progressFill) {
      progressFill.style.width = ((currentTimelineStep + 1) / totalSteps) * 100 + '%';
    }

    document.querySelectorAll('.progress-marker').forEach(function (marker, index) {
      marker.classList.toggle('active', index <= currentTimelineStep);
    });

    var currentStepEl = document.getElementById('currentStep');
    if (currentStepEl) currentStepEl.textContent = currentTimelineStep + 1;

    var prevBtn = document.getElementById('prevBtn');
    var nextBtn = document.getElementById('nextBtn');
    if (prevBtn) prevBtn.disabled = currentTimelineStep === 0;
    if (nextBtn) nextBtn.disabled = currentTimelineStep === totalSteps - 1;
  }

  window.nextStep = function () {
    if (currentTimelineStep < totalSteps - 1) {
      currentTimelineStep++;
      updateTimeline();
    }
  };

  window.previousStep = function () {
    if (currentTimelineStep > 0) {
      currentTimelineStep--;
      updateTimeline();
    }
  };

  window.goToStep = function (stepIndex) {
    if (stepIndex >= 0 && stepIndex < totalSteps) {
      currentTimelineStep = stepIndex;
      updateTimeline();
    }
  };

  function setupTestimonialLayout() {
    var slider = document.getElementById('testimonialSlider');
    if (!slider) return;

    var testimonials = slider.querySelectorAll('.testimonial');
    totalTestimonials = testimonials.length;
    if (!totalTestimonials) return;

    if (isMobileCarousel()) {
      slider.style.width = totalTestimonials * 100 + '%';
      testimonials.forEach(function (t) {
        t.style.width = 100 / totalTestimonials + '%';
      });
      updateTestimonialSlider();
    } else {
      slider.style.width = '';
      slider.style.transform = '';
      testimonials.forEach(function (t) {
        t.style.width = '';
      });
    }
  }

  function updateTestimonialSlider() {
    if (!isMobileCarousel()) return;

    var slider = document.getElementById('testimonialSlider');
    if (!slider || !totalTestimonials) return;

    var slideWidth = 100 / totalTestimonials;
    slider.style.transform = 'translateX(' + (-currentTestimonial * slideWidth) + '%)';

    document.querySelectorAll('.carousel-dot').forEach(function (dot, index) {
      dot.classList.toggle('active', index === currentTestimonial);
    });

    var prevBtn = document.getElementById('prevTestimonial');
    var nextBtn = document.getElementById('nextTestimonial');
    if (prevBtn) prevBtn.disabled = currentTestimonial === 0;
    if (nextBtn) nextBtn.disabled = currentTestimonial === totalTestimonials - 1;
  }

  window.nextTestimonial = function () {
    if (!isMobileCarousel()) return;
    if (currentTestimonial < totalTestimonials - 1) {
      currentTestimonial++;
      updateTestimonialSlider();
    }
  };

  window.previousTestimonial = function () {
    if (!isMobileCarousel()) return;
    if (currentTestimonial > 0) {
      currentTestimonial--;
      updateTestimonialSlider();
    }
  };

  window.goToTestimonial = function (index) {
    if (!isMobileCarousel()) return;
    if (index >= 0 && index < totalTestimonials) {
      currentTestimonial = index;
      updateTestimonialSlider();
    }
  };

  window.toggleAccordion = function (element) {
    var isActive = element.classList.contains('active');
    document.querySelectorAll('.ingredient-accordion').forEach(function (accordion) {
      accordion.classList.remove('active');
    });
    if (!isActive) element.classList.add('active');
  };

  document.addEventListener('DOMContentLoaded', function () {
    var timelineSteps = document.querySelectorAll('.timeline-step');
    if (timelineSteps.length) {
      totalSteps = timelineSteps.length;
      updateTimeline();
    }

    setupTestimonialLayout();
    window.addEventListener('resize', setupTestimonialLayout);
  });
})();
